<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin' && rol != 'admin-empresa'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container xl fluid v-else>
            <v-row>
                <v-col lg="12">
                    <data-table
                        ref="tableIncidencia"
                        :tableName="'Incidencias de asistencia'"
                        :showAdvancedFilters="false"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        @loadModalData="loadModalData"
                        :perPage="[10, 25, 50, 100]"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar" style="padding-right: 12px;">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td>
                                    <div>
                                        {{ item.nombre_cliente }}
                                    </div>
                                    <div>
                                        {{ item.nombre_empresa }}
                                    </div>

                                    <div v-if="item.nombre_cliente == null">
                                        General
                                    </div>
                                    <div v-if="item.nombre_empresa == null">
                                        Incidencia General
                                    </div>
                                </td>

                                <td>
                                    <div>{{ item.nombre }}</div>
                                </td>

                                <td>
                                    <div >
                                        <v-chip
                                            :color="item.color"
                                            style="width:100px"
                                        >
                                        </v-chip>
                                    </div>
                                </td>
                                <td
                                    v-if="item.empresa_id !== null"
                                >   
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="abrirModal('update', item)"
                                                    small
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="eliminar(item.id, item.nombre)"
                                                    small
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                                <td v-else><div><div style="height:60px"></div></div></td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <template>
            <v-layout row justify-center>
                <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>

                    <perfect-scrollbar style="background:#FFF">
                        <v-card elevation="0">
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <img :src="imgModal" class="imgModal" />
                                    <h2 class="titleModal">{{ titulo_modal }}</h2>
                                </div>
                            </v-card-title>

                            <v-card-text class="card_texto">
                                <div id="loadingModal" v-show="!finaliza_carga">
                                    <div id="loading">
                                        <v-progress-circular
                                            indeterminate
                                            :size="100"
                                            :width="7"
                                            color="blue"
                                        ></v-progress-circular>
                                    </div>
                                </div>

                                <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                    <v-divider class="divider"></v-divider>
                                    <v-row>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Nombre"
                                                v-model="incidencia.nombre"
                                                v-validate="'required'"
                                                data-vv-name="Nombre"
                                                :error-messages="errors.collect('Nombre')"
                                            />
                                        </v-col>

                                        <template>
                                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <v-select
                                                    outlined
                                                    :items="colores"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Color"
                                                    persistent-hint
                                                    v-model="incidencia.color_id"
                                                    v-validate="'required'"
                                                    data-vv-name="Color"
                                                    :error-messages="errors.collect('Color')"
                                                >
                                                    <template slot="selection" slot-scope="data">
                                                        <v-chip
                                                            :input-value="data.selected"
                                                            class="chip--select-multi"
                                                            :color="data.item.nombre"
                                                            style="width:100px"
                                                        >
                                                        </v-chip>
                                                    </template>

                                                    <template slot="item" slot-scope="data">
                                                        <!-- <template v-if="typeof data.item !== 'object'"> -->
                                                        <template v-if="validar(data.item)">
                                                            <div>{{ data.item }}</div>
                                                        </template>
                                                        <template v-else>
                                                            <v-chip
                                                                :input-value="data.selected"
                                                                class="chip--select-multi"
                                                                :color="data.item.nombre"
                                                                style="width:100px"
                                                            >
                                                            </v-chip>
                                                        </template>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </template>

                                        <template v-if="rol == 'root'">
                                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <v-autocomplete
                                                    outlined
                                                    :items="clientes"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Cliente"
                                                    persistent-hint
                                                    v-model="cliente_value"
                                                    v-validate="'required'"
                                                    data-vv-name="Cliente"
                                                    :error-messages="errors.collect('Cliente')"
                                                />
                                            </v-col>
                                        </template>

                                        <template v-if="rol == 'root' || rol == 'admin'">
                                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <v-autocomplete
                                                    outlined
                                                    :items="empresas"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Empresa"
                                                    persistent-hint
                                                    v-model="empresa_id"
                                                    v-validate="'required'"
                                                    data-vv-name="Empresa"
                                                    :error-messages="errors.collect('Empresa')"
                                                />
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions v-show="finaliza_carga" class="d-flex justify-end card_accion">
                                <button
                                    class="btnCerrar"
                                    @click="cerrarModal()"
                                    :disabled="loading_guardar"
                                >
                                    Cancelar
                                </button>
                                <v-btn
                                    class="btnGuardar"
                                    @click="guardar()"
                                    :loading="loading_guardar"
                                >
                                    Guardar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </perfect-scrollbar>
                </v-dialog>
            </v-layout>
        </template>
    </div>
</template>

<script>
import documentoApi from "../api/tipo_documentos";
import empresaApi from "../api/empresas";
import sucursalApi from "../api/sucursales";
import tipoincidenciasApi from "../api/tiposIncidencias";
import clientesApi from "../api/clientes";
import catalogosApi from "../api/catalogos";
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import Datatable from "@/components/datatable/Datatable.vue";
import Notify from "@/plugins/notify";
import PerfectScrollbar from "perfect-scrollbar";

export default {
    components: {
        "data-table": Datatable,
    },
    data() {
        return {
            url: "catalogo/tipos-incidencias/find",
            columns: [
                {
                    label: "Cliente",
                    name: "cliente",
                    filterable: true,
                },
                {
                    label: "Nombre incidencia",
                    name: "nombre",
                    filterable: true,
                },
                {
                    label: "Color",
                    name: "color",
                    filterable: true,
                },
                {
                    label: "Opciones",
                    name: "opciones",
                    filterable: false,
                    align: 'center'
                },
            ],
            filters: {
                activo          : true,
                paginate        : true,
                include_padres  : true,
                cliente_id      : null,
                empresa_id      : null,
                order_by        : 'nombre',
            },

            empresa_value_search    : null,
            sucursal_value_search   : null,
            cliente_value_search    : null,

            empresa_search          : [],
            sucursal_search         : [],
            clientes_search         : [],

            advancedSearch  : {
                nombre      : "",
                correo      : "",
                direccion   : "",
                telefono    : "",
            },

            loading_guardar : false,
            loading         : true,
            dialog          : false,
            search          : "",
            datosLogin      : "",
            menu            : false,
            incidencia      : {
                id          : 0,
                nombre      : null,
                cliente_id  : null,
                empresa_id  : null,
                color_id    : null,
            },
            titulo_modal    : "",
            finaliza_carga  : false,
            accion          : "",

            sucursales      : [],
            clientes        : [],
            empresas        : [],
            colores         : [],
            rol             : null,
            conteo_parametros: 0,
            carga_final     : 0,
            empresa_value   : null,
            cliente_value   : null,
            empresa_id      : null,
            busqueda        : false,
            imgModal        : "/static/modal/tipoIncidenciaCreate.svg",
        };
    },
    watch: {
        cliente_value: function(val) {
            if(val != null){
                this.cambiaCliente(val);
            }
        },
        cliente_value_search: function(val) {
            if(val != null){
                this.cambiaCliente(val);
            }
        },
    },
    methods: {
        ...mapActions("auth", ["notificacion"]),
        validar(item){
            if(typeof item !== 'object'){
                return true;
            }
            else{
                return false;
            }
        },
        listar() {
            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;
            this.resetValues();
            this.getColores();
            if (this.rol == "root") {
                this.getClientes();
            }

            if (this.rol == "admin") {
                this.filters.cliente_id = this.cliente_value = this.datosLogin.cliente_id;
            }

            if (this.rol == "admin-empresa") {
                this.columns[0].label = "Empresa";
                this.columns[0].name = "empresa";
                this.filters.empresa_id = this.empresa_id = this.datosLogin.empresa_id;
            }

            this.busquedaAvanzada();
        },
        setFilters() {
            let cliente = this.cliente_value_search;
            let empresa = this.empresa_value_search;

            if (this.rol == "admin") {
                cliente = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                empresa = this.datosLogin.empresa_id;
            } else {
            }

            let filterParams = {
                cliente_id: cliente,
                empresa_id: empresa,
            };

            let defaultParams = {
                activo: true,
                paginate: true,
                include_padres: true,
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filters = defaultParams;
            this.cliente_value_search = null;
            this.empresa_value_search = null;
            this.sucursal_value_search = null;
        },
        async loadModalData() {
            await this.resetValues();

            if (this.rol == "root") {
                this.getClientes();
            } else if (this.rol == "admin") {
                this.cliente_value_search = this.filters.cliente_id = this.datosLogin.cliente_id;
                this.cambiaCliente(this.datosLogin.cliente_id);
            } else if (this.rol == "admin-empresa") {
                this.empresa_value_search = this.filters.empresa_id = this.datosLogin.empresa_id;
            }
        },
        async abrirModal(accion, item = null) {
            await this.resetValues();
            await this.finaliza_parametros();
            this.errors.clear();
            this.accion = accion;
            if (accion == "add") {
                this.titulo_modal = "Registro de tipo de incidencia.";
                this.imgModal = "/static/modal/tipoIncidenciaCreate.svg";
                this.finaliza_parametros();
            } else if (accion == "update") {
                this.imgModal = "/static/modal/tipoIncidenciaUpdate.svg";
                this.titulo_modal = "Actualizar tipo de incidencia.";
                this.incidencia.id = item.id;
                this.incidencia.nombre = item.nombre;
                this.incidencia.color_id = item.color_id;
                this.cliente_value = item.cliente_id;
                this.incidencia.cliente_id = item.cliente_id;
                this.empresa_id = item.empresa_id;
                this.incidencia.empresa_id = item.empresa_id;
            }

            if (this.rol == "root") {
                this.getClientes();
                this.finaliza_parametros();
            }
            if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.cambiaCliente(this.datosLogin.cliente_id, this.empresa_id);
            } else if (this.rol == "admin-empresa") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_id = this.datosLogin.empresa_id;
            }
            setTimeout(function() {
                document.getElementById("btnModal").click();
            }, 100);
        },
        getClientes() {
            let parametros = { activo: true, paginate: false };
            clientesApi.getClientes(parametros).then((response) => {
                this.clientes_search = this.clientes = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        getEmpresas(id) {
            let parametros = { activo: true, paginate: false, cliente_id: id };
            empresaApi.getEmpresas(parametros).then((response) => {
                this.empresas = response.data;
                if (this.accion == "update") {
                    this.cliente_value = this.incidencia.cliente_id;
                }
                this.finaliza_parametros();
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        getColores() {
            let parametros = {
                activo: true,
                paginate: false,
                order: "asc",
            };
            catalogosApi.getColores(parametros).then((response) => {
                this.colores = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los colores.");
            });
        },
        cambiaEmpresa(id, sucursal = null) {
            let parametros = { activo: true, paginate: false, empresa_id: id };
            sucursalApi.getSucursales(parametros).then((response) => {
                this.sucursal_search = response.data;
                this.finaliza_parametros();
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        cambiaCliente(id, empresa = null) {
            let parametros = { activo: true, paginate: false, cliente_id: id };
            empresaApi.getEmpresas(parametros).then((response) => {
                this.empresa_search = this.empresas = response.data;
                if (this.accion != "add") {
                    this.incidencia.empresa_id = this.empresa_id;
                }
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
            this.finaliza_parametros();
        },
        guardar() {
            this.$validator.validate().then((result) => {
                if (result) {
                    this.loading_guardar = true;

                    this.incidencia.cliente_id = this.cliente_value;
                    this.incidencia.empresa_id = this.empresa_id;

                    if (this.accion === "add") {
                        tipoincidenciasApi.addTipoIncidencia(this.incidencia).then((response) => {
                            this.$refs.tableIncidencia.getData();
                            this.respuesta_ok("Registro creado correctamente");
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    } else if (this.accion === "update") {
                        tipoincidenciasApi.updateTipoIncidencia(this.incidencia).then((response) => {
                            this.respuesta_ok("Se ha actualizacion correctamente");
                            this.$refs.tableIncidencia.getData();
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    }
                }
            });
        },
        eliminar(id, nombre) {
            let self = this;
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el tipo incidencia " + nombre + "?",
                "Eliminar",
                () => {
                    this.loading = true;
                    tipoincidenciasApi.deleteTipoIncidencia(id).then(() => {
                        this.$refs.tableIncidencia.getData();
                        this.listar();
                        Notify.Success("Tipo incidencia eliminado","El tipo de incidencia ha sido eliminado satisfactoriamente");
                    })
                    .catch((err) => {
                        console.log(err);
                        Notify.ErrorToast(err.response.data.error);
                    });
                }
            );
        },
        finaliza_parametros() {
            this.carga_final = this.carga_final + 1;
            if (this.carga_final == 3) {
                this.finaliza_carga = true;
            }
        },
        resetValues() {
            this.incidencia.color_id    = null;
            this.cliente_value          = null;
            this.empresa_value          = null;
            this.cliente_id             = null;

            this.cliente_value_search   = null;
            this.empresa_value_search   = null;

            this.clientes               = [];
            this.empresas               = [];
            this.accion                 = "";

            this.sucursales             = [];
            this.clientes               = [];
            this.empresas               = [];
        },
        cerrarModal() {
            this.dialog = false;
            this.cliente_value = null;
            this.empresa_id = null;
            this.incidencia = {
                id: 0,
                nombre: "",
                empresa_id: null,
                cliente_id: null,
            };
            this.conteo_parametros = 0;
            this.carga_final = 0;
            this.loading_guardar = false;
        },
        respuesta_error(err) {
            this.cerrarModal();
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        respuesta_ok(msj) {
            this.listar();
            this.cerrarModal();
            Notify.Success("Operación exitosa", msj);
        },
        busquedaAvanzada() {
            switch (this.rol) {
                case "root":
                    this.busqueda = true;
                    break;
                case "admin":
                    this.busqueda = true;
                    break;
                case "admin-empresa":
                    this.busqueda = false;
                    break;
                default:
                    return false;
                    break;
            }
        },
        init() {
            const elementScroll = document.querySelector("#scroll");
            if (elementScroll) {
                const ps = new PerfectScrollbar(elementScroll, {
                wheelSpeed: 2,
                wheelPropagation: true,
                minScrollbarLength: 20,
                suppressScrollY: true,
                });
            }
            $(".ps__thumb-x").css("position", "fixed");
            /* $("tr th:nth-child(2)").css("width", "35%"); */
        },
        redireccionar(){
            this.$router.push('/dashboard');
        }
    },
    created() {
        this.listar();
    },
    mounted() {
        
    },
};
</script>
